/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/club-post.html';
import controller from './controllers/clubpostController';
import './views/club.scss';
var module = angular.module('clubPost', [
    //import modules
]).controller('clubPost', controller);

module.constant('clubPost', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('clubPost', {
//             parent: 'app',
//             url: '/club-post',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'clubPost'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/club_activity/clubModule.js